import MailingTemplatesModalView from "./mailingTemplatesModal.html";
import MailingsEditView from "./mailings-edit.html";


angular.module("mailings")

    .controller('MailingsListCtrl', ['entity_type', '$stateParams', '$timeout', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$filter', '$state', '$uibModal', 'LoginService', 'logService',
        function (entity_type, $stateParams, $timeout, $rootScope, $scope, Restangular, gridService, modalService, $filter, $state, $uibModal, LoginService, logService) {

        $scope.show_title = (entity_type != "correspondence");
        $scope.eventId = null;
        $scope.entity_type = entity_type;

            if (entity_type == "events") {
                $scope.allowAutomaticMailing = LoginService.permissionExist("AUTOMATIC_MAILINGS");
                $rootScope.title = $scope.event.name + " - " + $filter('translate')('mailing.title');
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('events.title'), url: "events.list" },
                    { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                    { title: $filter('translate')('mailing.title') }
                ];

            } else {
                $scope.allowAutomaticMailing = false;
            }

            $scope.selectMailings = [];

            // Lo paso a función para recargar las opciones cuando se crea un mailing nuevo
            let loadSelectMailings = function () {
                logService.debug('entramos aquí')
                Restangular.all('Mailings').getList({ entity_type: entity_type, entity_type_id: $stateParams.id }).then(function (mailings) {
                    $scope.selectMailings = mailings;
                    $scope.selectMailings.push({ id: null, title: "-Vacio-" });
                });
            }

            loadSelectMailings();

        var event = null;
        if (typeof ($stateParams.id) !== 'undefined') {
            $scope.eventId = $stateParams.id;
            if (entity_type == "events") {
                Restangular.one('Events', $stateParams.id).get().then(function (results) {
                    event = results;
                });
            }
        }

        $rootScope.title = $filter('translate')('mailing.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('notifications.list') }
        ];

        $scope.search = {
            subject: "",
            date_from: null,
            date_to: null
        };

        $scope.gridOptionMailings = {
            pdfTitle: $filter('translate')('notifications.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 30,
            enableFiltering: false,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'short_title', displayName: $filter('translate')('mailing.short_title'), enableFiltering: true, enableHiding: false, enableColumnMenu: false,width: 120 },
                {
                    name: 'title', displayName: $filter('translate')('mailing.name_title'), enableFiltering: true, enableHiding: false, enableColumnMenu: false,
                    cellTemplate: '<div><span>{{row.entity.title}}</span> <span ng-if="row.entity.obsolete_mailing" style="color: #d67b67;">' + $filter('translate')('general.obsolete_template') + '</span></div>'
                },
                { name: 'mailing_icon', displayName: $filter('translate')('menus.icon'), enableFiltering: true, enableHiding: false, enableColumnMenu: false, width: 120, cellTemplate: "<div class=\"{{row.entity.icon}}\" style=\"text-align: center;\">&nbsp;</div>" },
                { name: 'subject', displayName: $filter('translate')('notifications.subject'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'modified_by_name', displayName: $filter('translate')('general.modified_by'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                {
                    name: 'attachtment', displayName: $filter('translate')('correspondence.attachtment'), enableFiltering: true, enableHiding: true, width: 70,
                    cellTemplate: '<div ng-if="row.entity.FK_mailing_attachment_mailing.length > 0" class="fa fa-paperclip fa-lg" style="color: #1ab394;"></div>'
                },
                {
                    name: ' ', width: 100, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: "<div class='ui-grid-cell-contents'>" +
                        '<div class="btn-group" uib-dropdown dropdown-append-to-body>' +
                        '<button uib-dropdown-toggle class="btn btn-xs btn-default btn-outline dropdown-toggle">' + $filter('translate')('inscriptions_forms.actions') + '<span class="caret"></span></button>' +
                        '<ul style="overflow: visible;" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu>' +
                        '<li ng-if="!row.entity.is_system"><a ng-click="grid.appScope.duplicate(row.entity.id)"><i class="fa fa-copy"></i> ' + $filter('translate')('general.button_duplicate') + '</a></li>' +
                        '<li><a ng-click="grid.appScope.goToEdit(row.entity)"><i class="fa fa-edit"></i> ' + $filter('translate')('general.edit') + '</a></li>' +
                        '<li ng-if="!row.entity.is_system"><a ng-click="grid.appScope.deleteInternalDialog(row.entity.id,row.entity.subject);"><i class="fa fa-remove"></i> ' + $filter('translate')('general.button_delete') + '</a></li>' +
                        '<li><a ng-click="grid.appScope.goToNotificationList(row.entity.id)"><i class="fa fa-eye"></i> ' + $filter('translate')('mailing.notification_view') + '</a></li>' +
                        '</ul>' +
                        '</div>' +
                        '</div>'

                }
            ],
            getData: function (options) {
                options.subject = $scope.search.subject;
                if ($scope.eventId != null) options.entity_type_id = $scope.eventId;
                if (entity_type != null) options.entity_type = entity_type;
                return Restangular.all('Mailings').getList(options);
            }

            };

            $scope.duplicate = function (id) {

                var params = { mailingId: id, eventId: $scope.eventId };
                Restangular.all('Mailings').customPOST({}, "DuplicateMailing", params).then(function (result) {
                    if (result.id > 0) {
                        toastr.success($filter('translate')('mailings.create_success'));
                        $scope.gridOptionMailings.loadData();
                        loadSelectMailings();
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });

            }

            $scope.saveMailingId = function () {

            $scope.event.put().then(function (result) {
            });

        }

        $scope.searchNotifications = function () {
            if (angular.isDefined($scope.gridOptionMailings.loadData)) {
                $scope.gridOptionMailings.loadData(false);
            }
        }

        $scope.deleteInternalDialog = function (id, name) {
            modalService.confirm({
                title: $filter('translate')('general.delete'),
                message: $filter('translate')('general.delete_message') + " " + name + "?",
                onAccept: function () {
                    Restangular.one('Mailings', id).remove().then(function () {
                        toastr.success($filter('translate')('general.delete_success'));
                        $scope.gridOptionMailings.loadData(false);
                        loadSelectMailings();
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.goToNotificationList = function (id) {
                $state.go("events.edit.notifications", { event: $scope.eventId, mailing_id: id });
        }

            $scope.addFromTemplate = function () {
                if (event.mail_account_id == null) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('mailing.message_not_mailAccount'),
                        onAccept: function () { }
                    });
                } else {
                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: MailingTemplatesModalView,
                        controller: "MailingTemplatesModalCtrl",
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            entity_type: function () {
                                return $scope.entity_type;
                            },
                            entity_type_id: function () {
                                return $scope.eventId;
                            },

                        }
                    });

                    $modalInstance.result.then(function (results) {
                        $scope.gridOptionMailings.loadData(false);
                        loadSelectMailings();
                        $scope.goToEdit(results);
                    });
                }
        }
    
        $scope.goToEdit = function (rowEntity) {
            //if (rowEntity.entity_type == null) {
            //    $state.go("mailings.edit", { entityType: null, entityTypeId: rowEntity.entity_type_id, mailingId: null });
            //} else {

            if (typeof (rowEntity.id) == 'undefined' && rowEntity.entity_type == "events" && event.mail_account_id == null) {
                modalService.message({
                    title: "Error",
                    message: $filter('translate')('mailing.message_not_mailAccount'),
                    onAccept: function () { }
                });
            } else {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: MailingsEditView,
                    size: "lg",
                    controller: "MailingsEditCtrl",
                    resolve: {
                        mailingId: function () {
                            return rowEntity.id;
                        },
                        entityType: function () {
                            return rowEntity.entity_type;
                        },
                        entityTypeId: function () {
                            return rowEntity.entity_type_id;
                        }
                    },
                    windowClass: 'mailing-modal'
                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {
                    $timeout(function () {
                        loadSelectMailings();
                        $scope.gridOptionMailings.loadData(false);
                    }, 1000);
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
            }

        //    }

        }

    }])

    ;